// extracted by mini-css-extract-plugin
export default {"logo":"WalletHeading_logo__mLrKt"};